import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@/store/store'
import { selectOpenModalOutOfCredits, selectUser, selectUserIsSuper } from '@/store/slices/user/selectors'
import { showTextModal } from './textModalConfigs'
import { createOutOfCreditsModalConfig } from './modalAILimitReachedConfig'
import { SignInManager } from '@/scenes/Editor/components/Navbar/components/SignInManager'
import { useTranslation } from 'react-i18next'
import { formatAICreditsResetDate } from '@/utils/formatAICreditsResetDate'

function ModalAILimitReached() {
  const dispatch = useAppDispatch()
  const openModalOutOfCredits = useSelector(selectOpenModalOutOfCredits)
  const user = useSelector(selectUser)
  const userIsSuper = useSelector(selectUserIsSuper)
  const { i18n } = useTranslation()
  const [profileRefreshStatus, setProfileRefreshStatus] = useState<'idle' | 'refreshing' | 'done'>('idle')
  const didShowModalRef = useRef(false)

  useEffect(() => {
    if (!openModalOutOfCredits.isOpen) {
      didShowModalRef.current = false
      setProfileRefreshStatus('idle')
      return
    }
    if (didShowModalRef.current) return

    const pendingCallback = openModalOutOfCredits.callback
    const date = formatAICreditsResetDate(user?.next_credits_reset, i18n.language)

    if (!date && profileRefreshStatus === 'idle') {
      setProfileRefreshStatus('refreshing')
      void SignInManager.getInstance().refreshCurrentUserProfileFromServer()
        .finally(() => setProfileRefreshStatus('done'))
      return
    }

    if (!date && profileRefreshStatus === 'refreshing') {
      return
    }

    if (!date && profileRefreshStatus === 'done') {
      console.warn('Out-of-credits modal opened without next_credits_reset after profile refresh')
    }

    const modalConfig = createOutOfCreditsModalConfig({
      dispatch,
      userIsSuper,
      pendingCallback,
    })

    showTextModal(modalConfig.key, {
      vars: { date },
      onPrimary: modalConfig.onPrimary,
      onSecondary: modalConfig.onSecondary,
    })
    didShowModalRef.current = true
  }, [dispatch, i18n.language, openModalOutOfCredits.callback, openModalOutOfCredits.isOpen, profileRefreshStatus, user?.next_credits_reset, userIsSuper])

  return null
}

export default ModalAILimitReached
